import React from "react";

function IndexHeader() {
  return (
    <>
      {/* Inizio immagine di sfondo */}
      <div className="page-header section-dark"
        style={{
          backgroundImage:
            "url(" + require("assets/img/nodeTitolo.png") + ")",
        }}
      >
      </div>
      {/* Fine immagine di sfondo */}
    </>
  );
}

export default IndexHeader;
